import { https } from 'shared/utils/https';
import type { IGetModuleNavigationResponseDTO } from './module-navigation.dto';

const moduleNavigationApiVersion = 'v1';

const moduleNavigationBaseURL = `/${moduleNavigationApiVersion}/application/settings`;

export const moduleNavigationData = {
  getModulesNavigation: async (): Promise<IGetModuleNavigationResponseDTO> => {
    const { data } = await https.get<IGetModuleNavigationResponseDTO>(moduleNavigationBaseURL);
    return data;
  },
};
